//  Holds reference to global variables
const _globals = {};

class AppGlobals{

    static init(){

        if(process.env.NODE_ENV === 'development') {
            window['_globals'] = _globals;
        }

    }

    /**
     * Returns the global state object
     * @return {{}}
     */
    static getAll(){
        return _globals;
    }

    /**
     * Gets a global variable with the given key
     * @param key
     * @param cb
     */
    static get(key,cb){

        let v =  _globals[key];
        if(!v && typeof cb == "function") {
            return _globals[key] = cb();
        }

        return v;
    }

    /**
     * Sets or creates a new global variable
     * @param key
     * @param value
     */
    static set(key,value){
        _globals[key] = value;
        return value;
    }


    /**
     * Remove key
     * @param key
     */
    static remove(key){
        delete _globals[key];
    }
}

export default AppGlobals;


// WEBPACK FOOTER //
// ./src/common/AppGlobals.js